/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosResponse } from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { api } from 'services/api';
import { PayloadAction } from '@reduxjs/toolkit';
// import { PAGE_SIZE } from 'services/constants/env';
import { notificationContainer } from 'utils/notificationContainer';
import fileDownload from 'js-file-download';
import {
	getEmManagementListRequest,
	getEmManagementListSuccess,
	getEmByIdRequest,
	getEmByIdSuccess,
	getEmByIdFullRequest,
	getEmByIdFullSuccess,
	updateEmRequest,
	updateEmSuccess,
	updateEmFailure,
	updateEmerchantRequest,
	updateEmerchantSuccess,
	updateEmerchantFailure,
	unblockEmerchantRequest,
	unblockEmerchantSuccess,
	unblockEmerchantFailure,
	blockEmerchantRequest,
	blockEmerchantSuccess,
	blockEmerchantFailure,
	activateEmerchantRequest,
	activateEmerchantSuccess,
	activateEmerchantFailure,
	duplicateEmerchantRequest,
	duplicateEmerchantSuccess,
	duplicateEmerchantFailure,
	activateEuDdpRequest,
	activateEuDdpSuccess,
	activateEuDdpFailure,
	getAdditionalServicesRequest,
	getAdditionalServicesSuccess,
	createAdditionalServiceRequest,
	createAdditionalServiceSuccess,
	createAdditionalServiceFailure,
	updateAdditionalServiceRequest,
	updateAdditionalServiceSuccess,
	updateAdditionalServiceFailure,
	getEmAdditionalServicesRequest,
	getEmAdditionalServicesSuccess,
	createEmAdditionalServiceRequest,
	createEmAdditionalServiceSuccess,
	createEmAdditionalServiceFailure,
	updateEmAdditionalServiceRequest,
	updateEmAdditionalServiceSuccess,
	updateEmAdditionalServiceFailure,
	emAdditionalServiceInvoiceRequest,
	emAdditionalServiceInvoiceSuccess,
	emAdditionalServiceInvoiceFailure,
	emInvoicePdfRequest,
	emInvoicePdfSuccess,
	emInvoicePdfFailure,
	getSpecialRegistrationsRequest,
	getSpecialRegistrationsSuccess,
	addSpecialRegistrationRequest,
	addSpecialRegistrationSuccess,
	addSpecialRegistrationFailure,
	updateSpecialRegistrationRequest,
	updateSpecialRegistrationSuccess,
	updateSpecialRegistrationFailure,
	addScheduleTerminationRequest,
	addScheduleTerminationSuccess,
	addScheduleTerminationFailure,
	deleteScheduleTerminationRequest,
	deleteScheduleTerminationSuccess,
	deleteScheduleTerminationFailure,
	getEmEnumsRequest,
	getEmEnumsSuccess,
	getDistinctEnumNamesRequest,
	getDistinctEnumNamesSuccess,
	getDistinctEnumNamesFailure,
	getEnumByNameRequest,
	getEnumByNameSuccess,
	getEnumByNameFailure,
	getMonthlyFeesRequest,
	getMonthlyFeesSuccess,
	getFeeClassesRequest,
	getFeeClassesSuccess,
	// em comments
	getEmCommentsRequest,
	getEmCommentsSuccess,
	// em notifications
	getEmNotificationsRequest,
	getEmNotificationsSuccess,
	getEmCommentByIdRequest,
	getEmCommentByIdSuccess,
	createEmCommentRequest,
	createEmCommentSuccess,
	createEmCommentFailure,
	updateEmCommentRequest,
	updateEmCommentSuccess,
	updateEmCommentFailure,
	registerNominatedPersonAccountRequest,
	registerNominatedPersonAccountSuccess,
	registerNominatedPersonAccountFailure,
	// cancel em additional service
	emAdditionalServiceCancelRequest,
	emAdditionalServiceCancelSuccess,
	emAdditionalServiceCancelFailure,
	// em sites
	getEmSitesListRequest,
	getEmSitesListSuccess,
	createEmSiteRequest,
	createEmSiteSuccess,
	updateEmSiteRequest,
	updateEmSiteSuccess,
	deleteEmSiteRequest,
	deleteEmSiteSuccess,
	// dashboard users subscriptions
	getEmDashboardUsersSubscriptionsRequest,
	getEmDashboardUsersSubscriptionsSuccess,
	updateEmDashboardUsersSubscriptionsRequest,
	updateEmDashboardUsersSubscriptionsSuccess,
	updateEmDashboardUsersSubscriptionsFailure,
	// em invoice list
	getEmInvoiceListRequest,
	getEmInvoiceListSuccess,
	// em payment methods
	getEmPaymentMethodsRequest,
	getEmPaymentMethodsSuccess,
	getEmByIdFullFailure,
} from './reducer';
import { getEmKeycloakUsersRequest } from '../accessManagement/reducer';
import {
	TEmManagementListRequest,
	TEmManagementListResponsePayload,
	TEmManagementByIdResponsePayload,
	TEmManagementByIdRequest,
	TEmManagementByIdFullRequest,
	TEmManagementByIdFullResponsePayload,
	TEmManagementUpdateRequest,
	TEmManagementUpdateResponsePayload,
	TEmManagementEmerchantUpdateRequest,
	TEmManagementEmerchantUpdateResponsePayload,
	TEmManagementUnblockRequest,
	TEmManagementUnblockResponsePayload,
	TEmManagementBlockRequest,
	TEmManagementBlockResponsePayload,
	TEmManagementActivateRequest,
	TEmManagementActivateResponsePayload,
	TEmManagementDuplicateRequest,
	TEmManagementDuplicateResponsePayload,
	TEuDdpActivateRequest,
	TEuDdpActivateResponsePayload,
	TAdditionalServicesRequest,
	TAdditionalServicesResponsePayload,
	TAdditionalServiceCreateRequest,
	TAdditionalServiceCreateResponsePayload,
	TAdditionalServiceUpdateRequest,
	TAdditionalServiceUpdateResponsePayload,
	TEmAdditionalServicesResponsePayload,
	TEmAdditionalServiceCreateRequest,
	TEmAdditionalServiceCreateResponsePayload,
	TEmAdditionalServiceUpdateRequest,
	TEmAdditionalServiceUpdateResponsePayload,
	TEmAdditionalServiceInvoiceRequest,
	TEmAdditionalServiceInvoiceResponsePayload,
	TEmAdditionalServiceCancelRequest,
	TEmAdditionalServiceCancelResponsePayload,
	TEmInvoicePdfRequest,
	TEmInvoicePdfResponsePayload,
	TSpecialRegistrationsRequest,
	TSpecialRegistrationsResponsePayload,
	TSpecialRegistrationCreateRequest,
	TSpecialRegistrationCreateResponsePayload,
	TSpecialRegistrationUpdateRequest,
	TSpecialRegistrationUpdateResponsePayload,
	TScheduleTerminationCreateRequest,
	TScheduleTerminationCreateResponsePayload,
	TScheduleTerminationDeleteRequest,
	TScheduleTerminationDeleteResponsePayload,
	TEmEnumsRequest,
	TEmEnumsResponsePayload,
	TDistinctEnumNamesResponsePayload,
	TEnumByNameRequest,
	TMonthlyFeesResponsePayload,
	TFeeClassesResponsePayload,
	// em comments
	TEmCommentsRequest,
	TEmCommentsResponsePayload,
	// reuse types for notifications
	TEmCommentGetByIdRequest,
	TEmCommentGetByIdResponsePayload,
	TEmCommentCreateRequest,
	TEmCommentCreateResponsePayload,
	TEmCommentUpdateRequest,
	TEmCommentUpdateResponsePayload,
	TRegisterNominatedPersonAccountRequest,
	TRegisterNominatedPersonAccountResponsePayload,
	// em sites
	TEmSitesListRequest,
	TEmSitesListResponsePayload,
	TEmSiteCreateRequest,
	TEmSiteCreateResponsePayload,
	TEmSiteUpdateRequest,
	TEmSiteUpdateResponsePayload,
	TEmSiteDeleteRequest,
	TEmSiteDeleteResponsePayload,
	// dashboard users subscriptions
	TEmDashboardUsersSubscriptionsGetRequest,
	TEmDashboardUsersSubscriptionsGetResponsePayload,
	TEmDashboardUsersSubscriptionsUpdateRequest,
	TEmDashboardUsersSubscriptionsUpdateResponsePayload,
	// em invoice list
	TEmInvoiceListRequest,
	TEmInvoiceListResponsePayload,
	// em payment methods
	TEmPaymentMethodsRequest,
	TEmPaymentMethodsResponsePayload,
} from './types';
import { searchEuDdpRecordsRequest } from '../euDdp/reducer';
import { ESortDirection } from '../../../ui/EasTable/types';

function* getEmManagementListRequestWorker({ payload }: PayloadAction<TEmManagementListRequest>) {
	try {
		const response: TEmManagementListResponsePayload = yield call(
			api.emManagement.getEmManagementList,
			payload,
		);
		yield put(getEmManagementListSuccess(response));
		yield put(getEmByIdFullSuccess(null));
		yield put(updateEmerchantSuccess(null));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* getEmByIdRequestWorker({ payload }: PayloadAction<TEmManagementByIdRequest>) {
	try {
		const response: TEmManagementByIdResponsePayload = yield call(
			api.emManagement.getEmById,
			payload,
		);
		yield put(getEmByIdSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* getEmByIdFullRequestWorker({ payload }: PayloadAction<TEmManagementByIdFullRequest>) {
	try {
		const response: TEmManagementByIdFullResponsePayload = yield call(
			api.emManagement.getEmByIdFull,
			payload,
		);
		yield put(getEmByIdFullSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
			yield put(getEmByIdFullFailure(String(error.response?.data.message)));
		}
		// no failure action defined
	}
}

function* updateEmRequestWorker({ payload }: PayloadAction<TEmManagementUpdateRequest>) {
	try {
		const response: TEmManagementUpdateResponsePayload = yield call(
			api.emManagement.updateEm,
			payload,
		);
		yield put(updateEmSuccess(response));
		notificationContainer(response?.message ?? 'EM updated successfully', 'success');
		yield put(getEmByIdFullRequest({ id: payload.id }));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(updateEmFailure());
	}
}

function* updateEmerchantRequestWorker({
	payload,
}: PayloadAction<TEmManagementEmerchantUpdateRequest>) {
	try {
		const response: AxiosResponse<TEmManagementEmerchantUpdateResponsePayload> = yield call(
			api.emManagement.updateEmerchant,
			payload,
		);
		if (response.status === 210) {
			yield put(updateEmerchantSuccess(response.data));
			notificationContainer(
				'EM updated with warnings',
				// response.status === 210 ? 'warning' : 'success',
				'warning',
			);
		} else {
			yield put(updateEmerchantSuccess(null));
			notificationContainer(
				response?.data?.message ?? 'EM updated successfully',
				// response.status === 210 ? 'warning' : 'success',
				'success',
			);
		}

		yield put(getEmByIdFullRequest({ id: payload.id }));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(updateEmerchantFailure());
	}
}

function* unblockEmerchantRequestWorker({ payload }: PayloadAction<TEmManagementUnblockRequest>) {
	try {
		const response: TEmManagementUnblockResponsePayload = yield call(
			api.emManagement.unblockEmerchant,
			payload,
		);
		yield put(unblockEmerchantSuccess(response));
		notificationContainer('EM unblocked successfully', 'success');
		yield put(getEmByIdFullRequest({ id: payload.id }));
		yield put(getEmKeycloakUsersRequest({ emId: payload.id, pageSize: 100, pageNumber: 1 }));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(unblockEmerchantFailure());
	}
}

function* blockEmerchantRequestWorker({ payload }: PayloadAction<TEmManagementBlockRequest>) {
	try {
		const response: TEmManagementBlockResponsePayload = yield call(
			api.emManagement.blockEmerchant,
			payload,
		);
		yield put(blockEmerchantSuccess(response));
		notificationContainer('EM blocked successfully', 'success');
		yield put(getEmByIdFullRequest({ id: payload.id }));
		yield put(getEmKeycloakUsersRequest({ emId: payload.id, pageSize: 100, pageNumber: 1 }));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(blockEmerchantFailure());
	}
}

function* activateEmerchantRequestWorker({ payload }: PayloadAction<TEmManagementActivateRequest>) {
	try {
		const response: TEmManagementActivateResponsePayload = yield call(
			api.emManagement.activateEmerchant,
			payload,
		);
		yield put(activateEmerchantSuccess(response));
		notificationContainer('EM activated successfully', 'success');
		yield put(getEmByIdFullRequest({ id: payload.id }));
		yield put(getEmKeycloakUsersRequest({ emId: payload.id, pageSize: 100, pageNumber: 1 }));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(activateEmerchantFailure());
	}
}

function* duplicateEmerchantRequestWorker({
	payload,
}: PayloadAction<TEmManagementDuplicateRequest>) {
	try {
		const response: TEmManagementDuplicateResponsePayload = yield call(
			api.emManagement.duplicateEmerchant,
			payload,
		);
		yield put(duplicateEmerchantSuccess(response));
		notificationContainer(response?.message ?? 'EM duplicated successfully', 'success');
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(duplicateEmerchantFailure());
	}
}

function* activateEuDdpRequestWorker({ payload }: PayloadAction<TEuDdpActivateRequest>) {
	try {
		const response: TEuDdpActivateResponsePayload = yield call(
			api.emManagement.activateEuDdp,
			payload,
		);
		yield put(activateEuDdpSuccess(response));
		notificationContainer('EU DDP activated successfully', 'success');
		yield put(getEmByIdFullRequest({ id: payload.emId }));
		yield put(
			searchEuDdpRecordsRequest({
				filters: [{ fieldName: 'emId', value: String(payload.emId), operator: '=' }],
				pageNumber: 1,
				pageSize: 1,
				searchString: '',
			}),
		);
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(activateEuDdpFailure());
	}
}

function* getAdditionalServicesRequestWorker({
	payload,
}: PayloadAction<TAdditionalServicesRequest>) {
	try {
		const response: TAdditionalServicesResponsePayload = yield call(
			api.emManagement.getAdditionalServices,
			payload,
		);
		yield put(getAdditionalServicesSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		// yield put(assetsInitState());
	}
}

function* createAdditionalServiceRequestWorker({
	payload,
}: PayloadAction<TAdditionalServiceCreateRequest>) {
	try {
		const response: TAdditionalServiceCreateResponsePayload = yield call(
			api.emManagement.createAdditionalService,
			payload.data,
		);
		yield put(createAdditionalServiceSuccess(response));
		notificationContainer('Additional service created successfully', 'success');
		yield put(getAdditionalServicesRequest(payload.getAdditionalService));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(createAdditionalServiceFailure());
	}
}

function* updateAdditionalServiceRequestWorker({
	payload,
}: PayloadAction<TAdditionalServiceUpdateRequest>) {
	try {
		const response: TAdditionalServiceUpdateResponsePayload = yield call(
			api.emManagement.updateAdditionalService,
			payload,
		);
		yield put(updateAdditionalServiceSuccess(response));
		notificationContainer('Additional service updated successfully', 'success');
		yield put(getAdditionalServicesRequest(payload.getAdditionalService));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(updateAdditionalServiceFailure());
	}
}

function* getEmAdditionalServicesRequestWorker({ payload }: PayloadAction<number>) {
	try {
		const response: TEmAdditionalServicesResponsePayload = yield call(
			api.emManagement.getEmAdditionalServices,
			payload,
		);
		yield put(getEmAdditionalServicesSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
			yield put(getEmAdditionalServicesSuccess([]));
		}
		// yield put(assetsInitState());
	}
}

function* createEmAdditionalServiceRequestWorker({
	payload,
}: PayloadAction<TEmAdditionalServiceCreateRequest>) {
	try {
		const response: TEmAdditionalServiceCreateResponsePayload = yield call(
			api.emManagement.createEmAdditionalService,
			payload,
		);
		yield put(createEmAdditionalServiceSuccess(response));
		notificationContainer('EM additional service created successfully', 'success');
		// Refresh the list after creation
		yield put(getEmAdditionalServicesRequest(payload.emId));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(createEmAdditionalServiceFailure());
	}
}

function* updateEmAdditionalServiceRequestWorker({
	payload,
}: PayloadAction<TEmAdditionalServiceUpdateRequest>) {
	try {
		const response: TEmAdditionalServiceUpdateResponsePayload = yield call(
			api.emManagement.updateEmAdditionalService,
			payload,
		);
		yield put(updateEmAdditionalServiceSuccess(response));
		notificationContainer('EM additional service updated successfully', 'success');
		// Refresh the list after update
		yield put(getEmAdditionalServicesRequest(payload.data.emId));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(updateEmAdditionalServiceFailure());
	}
}

function* emAdditionalServiceInvoiceRequestWorker({
	payload,
}: PayloadAction<TEmAdditionalServiceInvoiceRequest>) {
	try {
		const response: TEmAdditionalServiceInvoiceResponsePayload = yield call(
			api.emManagement.emAdditionalServiceInvoice,
			payload.id,
		);
		yield put(emAdditionalServiceInvoiceSuccess(response));
		notificationContainer('EM additional service invoice generated successfully', 'success');
		yield put(getEmAdditionalServicesRequest(payload.emId));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(emAdditionalServiceInvoiceFailure());
	}
}

function* emInvoicePdfRequestWorker({ payload }: PayloadAction<TEmInvoicePdfRequest>) {
	try {
		const response: TEmInvoicePdfResponsePayload = yield call(
			api.emManagement.emInvoicePdf,
			payload,
		);
		yield put(emInvoicePdfSuccess(response));
		if (response) {
			fileDownload(response, `invoice_${String(payload.emId)}_${String(payload.invoiceId)}.pdf`);
		}

		notificationContainer('EM invoice PDF downloaded successfully', 'success');
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(emInvoicePdfFailure());
	}
}

function* emAdditionalServiceCancelRequestWorker({
	payload,
}: PayloadAction<TEmAdditionalServiceCancelRequest>) {
	try {
		const response: TEmAdditionalServiceCancelResponsePayload = yield call(
			api.emManagement.emAdditionalServiceCancel,
			payload,
		);
		yield put(emAdditionalServiceCancelSuccess(response));
		notificationContainer('EM additional service canceled successfully', 'success');
		yield put(getEmAdditionalServicesRequest(payload.emId));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(emAdditionalServiceCancelFailure());
	}
}

function* getSpecialRegistrationsRequestWorker({
	payload,
}: PayloadAction<TSpecialRegistrationsRequest>) {
	try {
		const response: TSpecialRegistrationsResponsePayload = yield call(
			api.emManagement.getSpecialRegistrations,
			payload,
		);
		yield put(getSpecialRegistrationsSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		// no failure action defined; mimic existing pattern
	}
}

function* addSpecialRegistrationRequestWorker({
	payload,
}: PayloadAction<TSpecialRegistrationCreateRequest>) {
	try {
		const response: TSpecialRegistrationCreateResponsePayload = yield call(
			api.emManagement.addSpecialRegistration,
			payload,
		);
		yield put(addSpecialRegistrationSuccess(response));
		notificationContainer('Special registration added successfully', 'success');
		yield put(getSpecialRegistrationsRequest({ emId: payload.emId } as any));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(addSpecialRegistrationFailure());
	}
}

function* updateSpecialRegistrationRequestWorker({
	payload,
}: PayloadAction<TSpecialRegistrationUpdateRequest>) {
	try {
		const response: TSpecialRegistrationUpdateResponsePayload = yield call(
			api.emManagement.updateSpecialRegistration,
			payload,
		);
		yield put(updateSpecialRegistrationSuccess(response));
		notificationContainer('Special registration updated successfully', 'success');
		yield put(getSpecialRegistrationsRequest({ emId: payload.emId } as any));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(updateSpecialRegistrationFailure());
	}
}

function* addScheduleTerminationRequestWorker({
	payload,
}: PayloadAction<TScheduleTerminationCreateRequest>) {
	try {
		const response: TScheduleTerminationCreateResponsePayload = yield call(
			api.emManagement.addScheduleTermination,
			payload,
		);
		yield put(addScheduleTerminationSuccess(response));
		notificationContainer('Schedule termination added successfully', 'success');
		yield put(getSpecialRegistrationsRequest({ emId: payload.emId } as any));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(addScheduleTerminationFailure());
	}
}

function* deleteScheduleTerminationRequestWorker({
	payload,
}: PayloadAction<TScheduleTerminationDeleteRequest>) {
	try {
		const response: TScheduleTerminationDeleteResponsePayload = yield call(
			api.emManagement.deleteScheduleTermination,
			payload,
		);
		yield put(deleteScheduleTerminationSuccess(response));
		notificationContainer('Schedule termination deleted successfully', 'success');
		yield put(getSpecialRegistrationsRequest({ emId: payload.emId } as any));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(deleteScheduleTerminationFailure());
	}
}

function* getEmEnumsRequestWorker({ payload }: PayloadAction<TEmEnumsRequest>) {
	try {
		const response: TEmEnumsResponsePayload = yield call(api.emManagement.getEmEnums, payload);
		const sortedResponse = response?.sort((a, b) => a.displayName.localeCompare(b.displayName));
		yield put(getEmEnumsSuccess({ enumName: payload.enumName, data: sortedResponse ?? [] }));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		// no failure action by pattern
	}
}

/** Best readable message an enum request failure can offer, without falling back to `undefined`. */
const getErrorMessage = (error: unknown): string => {
	if (axios.isAxiosError(error)) {
		const responseMessage = error.response?.data?.message;
		if (responseMessage) {
			return String(responseMessage);
		}
		return error.response?.status
			? `Request failed with status ${error.response.status}`
			: error.message;
	}
	return 'Request failed';
};

/** The endpoint may answer with plain names or with objects wrapping them, so both are flattened here. */
const normalizeDistinctEnumNames = (response: TDistinctEnumNamesResponsePayload): string[] =>
	(response ?? [])
		.map((item) =>
			typeof item === 'string'
				? item
				: (item?.enumName ?? item?.name ?? item?.value ?? item?.displayName ?? ''),
		)
		.filter((name) => name !== '')
		.sort((a, b) => a.localeCompare(b));

function* getDistinctEnumNamesRequestWorker() {
	try {
		const response: TDistinctEnumNamesResponsePayload = yield call(
			api.emManagement.getDistinctEnumNames,
		);
		yield put(getDistinctEnumNamesSuccess(normalizeDistinctEnumNames(response)));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(getDistinctEnumNamesFailure());
	}
}

function* getEnumByNameRequestWorker({ payload }: PayloadAction<TEnumByNameRequest>) {
	try {
		const response: TEmEnumsResponsePayload = yield call(api.emManagement.getEnumByName, payload);
		const sortedResponse = [...(response ?? [])].sort((a, b) =>
			a.displayName.localeCompare(b.displayName),
		);
		yield put(getEnumByNameSuccess({ enumName: payload.enumName, data: sortedResponse }));
	} catch (error) {
		// Shown inline in the enum view instead of a toast, which would repeat on every reselect.
		yield put(
			getEnumByNameFailure({ enumName: payload.enumName, message: getErrorMessage(error) }),
		);
	}
}

function* getMonthlyFeesRequestWorker() {
	try {
		const response: TMonthlyFeesResponsePayload = yield call(api.emManagement.getMonthlyFees);
		const withoutNullFees = response?.map((a) =>
			a.description === null ? { ...a, description: '--' } : a,
		);
		const sortedResponse = withoutNullFees?.sort((a, b) => {
			const aDescription = a.description || '--';
			const bDescription = b.description || '--';
			return aDescription.localeCompare(bDescription);
		});
		yield put(getMonthlyFeesSuccess(sortedResponse ?? []));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		// no failure action by pattern
	}
}

function* getFeeClassesRequestWorker() {
	try {
		const response: TFeeClassesResponsePayload = yield call(api.emManagement.getFeeClasses);

		const sortedResponse = response?.sort((a, b) => {
			const aDescription = a.description || '--';
			const bDescription = b.description || '--';
			return aDescription.localeCompare(bDescription);
		});
		yield put(getFeeClassesSuccess(sortedResponse ?? []));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		// no failure action by pattern
	}
}

// ======================= EM COMMENTS =======================
function* getEmCommentsRequestWorker({ payload }: PayloadAction<TEmCommentsRequest>) {
	try {
		const response: TEmCommentsResponsePayload = yield call(
			api.emManagement.getEmComments,
			payload,
		);
		yield put(getEmCommentsSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		// no failure action by pattern
	}
}

// ======================= EM NOTIFICATIONS =======================
function* getEmNotificationsRequestWorker({ payload }: PayloadAction<TEmCommentsRequest>) {
	try {
		const response: TEmCommentsResponsePayload = yield call(
			api.emManagement.getEmNotifications,
			payload,
		);
		yield put(getEmNotificationsSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		// no failure action by pattern
	}
}

function* getEmCommentByIdRequestWorker({ payload }: PayloadAction<TEmCommentGetByIdRequest>) {
	try {
		const response: TEmCommentGetByIdResponsePayload = yield call(
			api.emManagement.getEmCommentById,
			payload,
		);
		yield put(getEmCommentByIdSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		// no failure action by pattern
	}
}

function* createEmCommentRequestWorker({ payload }: PayloadAction<TEmCommentCreateRequest>) {
	try {
		const response: TEmCommentCreateResponsePayload = yield call(
			api.emManagement.createEmComment,
			payload,
		);
		yield put(createEmCommentSuccess(response));
		notificationContainer('EM comment created successfully', 'success');
		if (payload.getEmCommentsRequest) {
			yield put(getEmCommentsRequest(payload.getEmCommentsRequest));
		}
		if (payload.getEmNotificationsRequest) {
			yield put(getEmNotificationsRequest(payload.getEmNotificationsRequest));
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(createEmCommentFailure());
	}
}

function* updateEmCommentRequestWorker({ payload }: PayloadAction<TEmCommentUpdateRequest>) {
	try {
		const response: TEmCommentUpdateResponsePayload = yield call(
			api.emManagement.updateEmComment,
			payload,
		);
		yield put(updateEmCommentSuccess(response));
		notificationContainer('EM comment updated successfully', 'success');
		if (payload.getEmCommentsRequest) {
			yield put(getEmCommentsRequest(payload.getEmCommentsRequest));
		}
		if (payload.getEmNotificationsRequest) {
			yield put(getEmNotificationsRequest(payload.getEmNotificationsRequest));
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(updateEmCommentFailure());
	}
}

function* registerNominatedPersonAccountRequestWorker({
	payload,
}: PayloadAction<TRegisterNominatedPersonAccountRequest>) {
	try {
		const response: TRegisterNominatedPersonAccountResponsePayload = yield call(
			api.emManagement.registerNominatedPersonAccount,
			payload,
		);
		yield put(registerNominatedPersonAccountSuccess(response));
		notificationContainer('Nominated person account registration sent', 'success');
		if (payload.id) {
			yield put(getEmByIdFullRequest({ id: payload.id }));
			yield put(getEmKeycloakUsersRequest({ emId: payload.id, pageSize: 100, pageNumber: 1 }));
		}
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(registerNominatedPersonAccountFailure());
	}
}

// ======================= EM SITES =======================
function* getEmSitesListRequestWorker({ payload }: PayloadAction<TEmSitesListRequest>) {
	try {
		const response: TEmSitesListResponsePayload = yield call(
			api.emManagement.getEmSitesList,
			payload,
		);
		yield put(getEmSitesListSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		// no failure action by pattern
	}
}

function* createEmSiteRequestWorker({ payload }: PayloadAction<TEmSiteCreateRequest>) {
	try {
		const response: TEmSiteCreateResponsePayload = yield call(
			api.emManagement.createEmSite,
			payload,
		);
		yield put(createEmSiteSuccess(response));
		notificationContainer('EM site created successfully', 'success');
		yield put(getEmSitesListRequest({ emId: payload.emId }));
		yield put(getEmByIdFullRequest({ id: payload.emId }));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		// no failure action by pattern
	}
}

function* updateEmSiteRequestWorker({ payload }: PayloadAction<TEmSiteUpdateRequest>) {
	try {
		const response: TEmSiteUpdateResponsePayload = yield call(
			api.emManagement.updateEmSite,
			payload,
		);
		yield put(updateEmSiteSuccess(response));
		notificationContainer('EM site updated successfully', 'success');
		yield put(getEmSitesListRequest({ emId: payload.emId }));
		yield put(getEmByIdFullRequest({ id: payload.emId }));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		// no failure action by pattern
	}
}

function* deleteEmSiteRequestWorker({ payload }: PayloadAction<TEmSiteDeleteRequest>) {
	try {
		const response: TEmSiteDeleteResponsePayload = yield call(
			api.emManagement.deleteEmSite,
			payload,
		);
		yield put(deleteEmSiteSuccess(response));
		notificationContainer('EM site deleted successfully', 'success');
		yield put(getEmSitesListRequest({ emId: payload.emId }));
		yield put(getEmByIdFullRequest({ id: payload.emId }));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		// no failure action by pattern
	}
}

// ======================= DASHBOARD USERS SUBSCRIPTIONS =======================
function* getEmDashboardUsersSubscriptionsRequestWorker({
	payload,
}: PayloadAction<TEmDashboardUsersSubscriptionsGetRequest>) {
	try {
		const response: TEmDashboardUsersSubscriptionsGetResponsePayload = yield call(
			api.emManagement.getDashboardUsersSubscriptions,
			payload,
		);
		yield put(getEmDashboardUsersSubscriptionsSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		// no failure action by pattern
	}
}

function* updateEmDashboardUsersSubscriptionsRequestWorker({
	payload,
}: PayloadAction<TEmDashboardUsersSubscriptionsUpdateRequest>) {
	try {
		const response: TEmDashboardUsersSubscriptionsUpdateResponsePayload = yield call(
			api.emManagement.updateDashboardUsersSubscriptions,
			payload,
		);
		yield put(updateEmDashboardUsersSubscriptionsSuccess(response));
		notificationContainer('Dashboard user subscriptions updated successfully', 'success');
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(updateEmDashboardUsersSubscriptionsFailure());
	}
}

// ======================= EM INVOICE LIST =======================
function* getEmInvoiceListRequestWorker({ payload }: PayloadAction<TEmInvoiceListRequest>) {
	try {
		const response: TEmInvoiceListResponsePayload = yield call(
			api.emManagement.getEmInvoiceList,
			payload,
		);
		yield put(getEmInvoiceListSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		yield put(getEmInvoiceListSuccess(null));
	}
}

// ======================= EM PAYMENT METHODS =======================
function* getEmPaymentMethodsRequestWorker({ payload }: PayloadAction<TEmPaymentMethodsRequest>) {
	try {
		const response: TEmPaymentMethodsResponsePayload = yield call(
			api.emManagement.getEmPaymentMethods,
			payload,
		);
		yield put(getEmPaymentMethodsSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error.response?.data.message), 'error');
		}
		// on error, reset to null to avoid stale data
		yield put(getEmPaymentMethodsSuccess(null));
	}
}

export function* emManagementSaga() {
	yield takeEvery(getEmManagementListRequest.type, getEmManagementListRequestWorker);
	yield takeEvery(getEmByIdRequest.type, getEmByIdRequestWorker);
	yield takeEvery(getEmByIdFullRequest.type, getEmByIdFullRequestWorker);
	yield takeEvery(updateEmRequest.type, updateEmRequestWorker);
	yield takeEvery(updateEmerchantRequest.type, updateEmerchantRequestWorker);
	yield takeEvery(unblockEmerchantRequest.type, unblockEmerchantRequestWorker);
	yield takeEvery(blockEmerchantRequest.type, blockEmerchantRequestWorker);
	yield takeEvery(activateEmerchantRequest.type, activateEmerchantRequestWorker);
	yield takeEvery(duplicateEmerchantRequest.type, duplicateEmerchantRequestWorker);
	yield takeEvery(activateEuDdpRequest.type, activateEuDdpRequestWorker);
	yield takeEvery(getAdditionalServicesRequest.type, getAdditionalServicesRequestWorker);
	yield takeEvery(createAdditionalServiceRequest.type, createAdditionalServiceRequestWorker);
	yield takeEvery(updateAdditionalServiceRequest.type, updateAdditionalServiceRequestWorker);
	yield takeEvery(getEmAdditionalServicesRequest.type, getEmAdditionalServicesRequestWorker);
	yield takeEvery(createEmAdditionalServiceRequest.type, createEmAdditionalServiceRequestWorker);
	yield takeEvery(updateEmAdditionalServiceRequest.type, updateEmAdditionalServiceRequestWorker);
	yield takeEvery(emAdditionalServiceInvoiceRequest.type, emAdditionalServiceInvoiceRequestWorker);
	yield takeEvery(emInvoicePdfRequest.type, emInvoicePdfRequestWorker);
	yield takeEvery(emAdditionalServiceCancelRequest.type, emAdditionalServiceCancelRequestWorker);
	yield takeEvery(getSpecialRegistrationsRequest.type, getSpecialRegistrationsRequestWorker);
	yield takeEvery(addSpecialRegistrationRequest.type, addSpecialRegistrationRequestWorker);
	yield takeEvery(updateSpecialRegistrationRequest.type, updateSpecialRegistrationRequestWorker);
	yield takeEvery(addScheduleTerminationRequest.type, addScheduleTerminationRequestWorker);
	yield takeEvery(deleteScheduleTerminationRequest.type, deleteScheduleTerminationRequestWorker);
	yield takeEvery(getEmEnumsRequest.type, getEmEnumsRequestWorker);
	yield takeEvery(getDistinctEnumNamesRequest.type, getDistinctEnumNamesRequestWorker);
	yield takeEvery(getEnumByNameRequest.type, getEnumByNameRequestWorker);
	yield takeEvery(getMonthlyFeesRequest.type, getMonthlyFeesRequestWorker);
	yield takeEvery(getFeeClassesRequest.type, getFeeClassesRequestWorker);
	// em comments
	yield takeEvery(getEmCommentsRequest.type, getEmCommentsRequestWorker);
	// em notifications
	yield takeEvery(getEmNotificationsRequest.type, getEmNotificationsRequestWorker);
	yield takeEvery(getEmCommentByIdRequest.type, getEmCommentByIdRequestWorker);
	yield takeEvery(createEmCommentRequest.type, createEmCommentRequestWorker);
	yield takeEvery(updateEmCommentRequest.type, updateEmCommentRequestWorker);
	yield takeEvery(
		registerNominatedPersonAccountRequest.type,
		registerNominatedPersonAccountRequestWorker,
	);
	// em sites
	yield takeEvery(getEmSitesListRequest.type, getEmSitesListRequestWorker);
	yield takeEvery(createEmSiteRequest.type, createEmSiteRequestWorker);
	yield takeEvery(updateEmSiteRequest.type, updateEmSiteRequestWorker);
	yield takeEvery(deleteEmSiteRequest.type, deleteEmSiteRequestWorker);
	// dashboard users subscriptions
	yield takeEvery(
		getEmDashboardUsersSubscriptionsRequest.type,
		getEmDashboardUsersSubscriptionsRequestWorker,
	);
	yield takeEvery(
		updateEmDashboardUsersSubscriptionsRequest.type,
		updateEmDashboardUsersSubscriptionsRequestWorker,
	);
	// em invoice list
	yield takeEvery(getEmInvoiceListRequest.type, getEmInvoiceListRequestWorker);
	// em payment methods
	yield takeEvery(getEmPaymentMethodsRequest.type, getEmPaymentMethodsRequestWorker);
}
